import script from "./InlineWechatBinding.vue?vue&type=script&setup=true&lang=ts"
export * from "./InlineWechatBinding.vue?vue&type=script&setup=true&lang=ts"

import "./InlineWechatBinding.vue?vue&type=style&index=0&id=74780082&scoped=true&lang=css"

import exportComponent from "G:\\IT\\landiyun4.0\\ldcustomer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74780082"]])

export default __exports__